// app/javascript/conversations/components/conversationsDisplay.jsx

import React, { useState, useEffect } from 'react';
import RowModal from 'projects/components/RowModal'
import ModalRow from 'projects/components/ModalRow'
import ChatRow from './ChatRow'
import ConversationActions from './ConversationActions';
import ConversationsAPI from './ConversationsAPI';

const ConversationPickerModal = (props) => {
  const [conversations, setConversations] = useState([])

  const {show, projectId, onHide, transcriptID='none', onConversationClick, users=null} = props;

  const loadConversations = () => {
    if (projectId && !!show) {
      ConversationActions.getConversations(projectId, { transcript_id: transcriptID, users }).then((data)=>{
        setConversations(data.data.conversations || []);
      });
    }
  };

  useEffect(() => {
    loadConversations();
  }, [show, projectId]);

  const handleDelete = async (conversationId) => {
    await ConversationsAPI.deleteConversation(conversationId);
    loadConversations(); // Refresh the list after deletion
  };

  return (
    <div>
      <RowModal
        bsSize="large"
        show={show}
        onHide={onHide}
        buttonText='New Conversation'
        buttonAction={true ? null : this.addProject}
        header={<h3 style={{marginTop:0}}>All Chats</h3>}
      >
        <ModalRow
          row={[
            <strong>Chat</strong>,
            <strong>Owner</strong>,
            <strong>Created At</strong>,
            <strong></strong>]}
        />
        
        {conversations.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).map((conversation, index) => {
          return <ChatRow
            key={conversation.id}
            created_at={conversation.created_at}
            name={conversation.first_message || 'No messages'}
            user_id={conversation.user_id}
            id={conversation.id}
            project_id={projectId}
            onHide={onHide}
            onDelete={handleDelete}
            onConversationClick={onConversationClick}/>
        })}
        {conversations.length === 0 &&
          <div style={{textAlign: 'center', fontSize: '1.2em', marginTop: '40px'}}>
              Your chat history will appear here once you start a chat
          </div>
        }
        
      </RowModal>
    </div>)
}

export default ConversationPickerModal;
